import { render, staticRenderFns } from "./lista-mini.vue?vue&type=template&id=8d8b59c0&scoped=true&"
import script from "./lista-mini.vue?vue&type=script&lang=ts&"
export * from "./lista-mini.vue?vue&type=script&lang=ts&"
import style0 from "./lista-mini.vue?vue&type=style&index=0&id=8d8b59c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8b59c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
